import { useMemo, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const BuildsList = ({ builds, selId, onSelect, onChanged }) => {
  const [q, setQ] = useState("");
  const [stars, setStars] = useState("");
  const [status, setStatus] = useState("");
  const [armed, setArmed] = useState("");
  const list = useMemo(() => builds
    .filter((b) => (!q || b.name.toLowerCase().includes(q.toLowerCase())) && (!stars || String(b.stars) === stars) && (!status || b.status === status))
    .sort((a, b) => (b.stars - a.stars) || a.name.localeCompare(b.name)), [builds, q, stars, status]);

  const confirm = (k, fn) => { if (armed !== k) { setArmed(k); setTimeout(() => setArmed(""), 5000); return; } setArmed(""); fn(); };
  const generate = () => confirm("gen", async () => {
    try { const { data } = await api.post("/builds/generate", {}); toast.success(`Drafts made for ${data.generated} heroes${data.kept ? `, kept ${data.kept} you edited` : ""}`); onChanged(); }
    catch (e) { toast.error(errMsg(e)); }
  });
  const publishGroup = () => confirm("pub", async () => {
    try { const { data } = await api.post("/builds/publish", stars ? { stars: Number(stars) } : { all: true }); toast.success(`Published ${data.changed} heroes`); onChanged(); }
    catch (e) { toast.error(errMsg(e)); }
  });
  const pub = builds.filter((b) => b.status === "published").length;

  return (
    <div className="lg-blist" data-testid="builds-list">
      <div style={{ fontSize: 12.5, color: "var(--muted)", marginBottom: 8 }} data-testid="builds-count">{pub} of {builds.length} published</div>
      <button className="lg-btn ghost sm" style={{ width: "100%", marginBottom: 6 }} onClick={generate} data-testid="builds-generate">
        {armed === "gen" ? "Press again: remake drafts (keeps your edits)" : builds.length ? "Remake auto drafts" : "Make drafts for every hero"}
      </button>
      <input className="lg-input" placeholder="Search hero" value={q} onChange={(e) => setQ(e.target.value)} style={{ marginBottom: 6 }} data-testid="builds-search" />
      <div style={{ display: "flex", gap: 6, marginBottom: 6 }}>
        <select className="lg-input" value={stars} onChange={(e) => setStars(e.target.value)} data-testid="builds-filter-stars">
          <option value="">All stars</option>{[5, 4, 3, 2].map((s) => <option key={s} value={s}>{s}★</option>)}
        </select>
        <select className="lg-input" value={status} onChange={(e) => setStatus(e.target.value)} data-testid="builds-filter-status">
          <option value="">Any status</option><option value="draft">Draft</option><option value="published">Published</option>
        </select>
      </div>
      <button className="lg-btn sm" style={{ width: "100%", marginBottom: 8 }} onClick={publishGroup} data-testid="builds-publish-group">
        {armed === "pub" ? "Press again to publish" : stars ? `Publish all ${stars}★` : "Publish every hero"}
      </button>
      <div className="lg-blist-items">
        {list.map((b) => (
          <button key={b.id} className={`lg-bitem${b.id === selId ? " on" : ""}`} onClick={() => onSelect(b.id)} data-testid={`builds-item-${b.id}`}>
            <span>{b.name}</span><small>{"★".repeat(b.stars || 0)} {b.editedBy ? "· edited" : ""}</small>
            <i className={b.status === "published" ? "pub" : ""}>{b.status === "published" ? "Live" : "Draft"}</i>
          </button>
        ))}
      </div>
    </div>
  );
};
